export default "__VITE_PUBLIC_ASSET__22886144__"